<template>
  <div class="device014_dimming_wraper device_control_page_wraper">
    <div class="close_img_top">
      <img
        src="~assets/img/controlpublic/control-guanbi-chahao.png"
        @click="$closeControlToast"
        alt
      />
    </div>
    <div class="devce_name z_ellipsis1">{{ objData.remark }}</div>

    <div class="content014_wraper content027_wraper">
      <div class="data014_show data_027show">
        <!-- <span>0%</span> -->
        <progress-bar
          v-on:valueChange="valueChange"
          :width="200"
          :maxValue="100"
          :setValue="userControlData.openStateValue"
        >
          <!-- <span slot="sliderTitle">白光:</span> -->
          <span slot="sliderLeftTips">0%</span>
          <span slot="sliderRightTips">100%</span>
        </progress-bar>
        <!-- <span>100%</span> -->
      </div>
      <div
        class="device_control_btn public_control_btn"
        :class="userControlData.openState ? 'public_control_btn_on' : ''"
        @click="device014BtnClickHandle"
      >{{ deviceStateComputed }}</div>
    </div>

    <!-- <BUtton @click="btnhandle">按钮</BUtton> -->
  </div>
</template>

<script>
///需要注意的是  调光进度条和 按钮之间的翻转逻辑 进度条大于0 按钮显示已打开 小于等于0显示 已关闭 。操作按钮打开 进度条100 关闭 进度条0
// import { controlBtnRequestHandle } from "components/content/control-toast/control-toast-classify/device-public-js";
import {
  deviceTypeJudge,
  deviceTypeJudge1,
  publicDeviceTypeJudge,
  deviceStateFlip
} from "components/content/contro-view/device-view/device-item-view-js";
import ProgressBar from "components/common/progressbar/progress-bar";
export default {
  data() {
    return {
      userControlData: this.objData ///场景配置 直接修改服务器的缓存数据 ， 不再进行用户数据缓存
      // {
      //   ///用户设置的缓冲数据
      //   openState: this.objData.openState, ///1开 或0关
      //   openStateValue: this.objData.openStateValue, //百分比
      //   openStateValue1: this.objData.openStateValue1, ///无用
      //   openStateValue2: this.objData.openStateValue2 ///无用
      // }
    };
  },
  props: {
    objData: Object ///要控制设备的数据
  },
  components: {
    ProgressBar
  },
  methods: {
    device014BtnClickHandle() {
      ///按钮按下
      deviceStateFlip(this.userControlData); ///对设备的状态0和1进行翻转
      console.log(this.userControlData.value);
      if (this.userControlData.openState === 1) {
        this.userControlData.openStateValue = 100;
        ////赋值设置状态
        this.userControlData.value.businessState = this.userControlData.openStateValue;
        if (this.userControlData.type === 1) {
          ///说明是有人时的选择
          this.userControlData.selectObjectInfo.businessState1 = this.userControlData.openStateValue;
        } else if (this.userControlData.type === 2) {
          ////说明是无人时的选择
          this.userControlData.selectObjectInfo.businessState2 = this.userControlData.openStateValue;
        }
      } else {
        this.userControlData.openStateValue = 0;
        ////赋值设置状态
        this.userControlData.value.businessState = this.userControlData.openStateValue;
        if (this.userControlData.type === 1) {
          ///说明是有人时的选择
          this.userControlData.selectObjectInfo.businessState1 = this.userControlData.openStateValue;
        } else if (this.userControlData.type === 2) {
          ////说明是无人时的选择
          this.userControlData.selectObjectInfo.businessState2 = this.userControlData.openStateValue;
        }
      }

      // controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    },
    valueChange(data) {
      ///进度条值改变
      console.log("子组件传回的值" + data);
      if (this.userControlData.openStateValue === data) return;
      this.userControlData.openStateValue = data;
      this.userControlData.value.businessState = data;
      if (this.userControlData.type === 1) {
        ///说明是有人时的选择
        this.userControlData.selectObjectInfo.businessState1 = this.userControlData.openStateValue;
      } else if (this.userControlData.type === 2) {
        ////说明是无人时的选择
        this.userControlData.selectObjectInfo.businessState2 = this.userControlData.openStateValue;
      }
      if (this.userControlData.openStateValue > 0) {
        this.userControlData.openState = 1;
      } else {
        this.userControlData.openState = 0;
      }
      // controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    }
    // btnhandle() {
    //   this.userControlData.openStateValue++;
    // }
  },
  computed: {
    deviceStateComputed() {
      if (this.userControlData.openState === 1) {
        return "已打开";
      } else {
        return "已关闭";
      }
    }
  },
  watch: {
    "objData.openState": {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val);
        this.userControlData.openState = val;
      }
    },
    "objData.openStateValue": {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val);
        this.userControlData.openStateValue = val;
      }
    }
  }
};
</script>

<style>
.device014_dimming_wraper {
  height: 400px;
}
.data014_show {
  margin-top: 20px;
  margin-bottom: 60px;
}
</style>
